import { useState } from "react";
import { toast } from "react-toastify";

interface Service<T> {
  getInfoById: (
    id: string,
    visibility?: "public" | "private"
  ) => Promise<{ data: T }>;
}

export const useEditHandler = <T>(service: Service<T>) => {
  const [editing, setEditing] = useState<boolean>(false);
  const [showForm, setShowForm] = useState<boolean | null>(null);

  const handleEditClick = async (
    data: T & { id?: string },
    visibility?: "public" | "private"
  ) => {
    setEditing(true);
    setShowForm(false); // This allows all data to load properly before showing the form again.
    if (data && data.id) {
      try {
        const response =
          visibility === undefined
            ? await service.getInfoById(data.id)
            : await service.getInfoById(data.id, visibility);
        const info = response.data;
        setShowForm(true);
        return info;
      } catch (error) {
        console.error("Error fetching listing info:", error);
        toast.error(
          "Failed to fetch listing information from the database. Please check the error details",
          {
            position: "bottom-right",
          }
        );
        return null;
      }
    }
  };

  return {
    handleEditClick,
    editing,
    showForm,
    setEditing,
    setShowForm,
  };
};
